// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1ld3l","log":"ModalInventoryLogs_log__3O2TF","date":"ModalInventoryLogs_date__24FPx","userName":"ModalInventoryLogs_userName__2fVdx"};